import { FC } from 'react';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useProductList } from '@/components/EcoCredits/api';
import EditorLink from 'lowcode/components/EditorLink';
import EditorImg from 'lowcode/components/EditorImg';
import { IPageStatus, ProductModule } from '@/components/EcocreditsMonthlyMadness/type';
import { useLang } from '@/app/utils/useLang';
import Header from '@/components/EcoCredits/CommonElement/Header';
import { useGlobal } from '@/utils/useGlobal';
import { useMonthlyStore } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';

type IProps = {
    title: string;
    id?: string;
    desc?: string;
    module: ProductModule;
};

const euList: { pc: string; h5: string }[] = [
    {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1731916784369/20241118-151622.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1731916784369/20241118-151622.jpg',
    },
    {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1731912554685/flash_sale_1_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1730971091564/flash_sale_m.jpg',
    },
    {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1730971565328/flashsale_3_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1730971570565/flashsale_3_m.jpg',
    },
    {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1730972128879/flashsale_4_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1730972133202/flashsale_4_m.jpg',
    },
    {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1730972182363/flashsale_5_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1730972175632/flashsale_5_m.jpg',
    },
    {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1730972203924/flashsale_6_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1730972209492/flashsale_6_m.jpg',
    },
];

const imgList: Record<string, { pc: string; h5: string }[]> = {
    eu: euList,
    uk: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730972380677/flashsale_1_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730887460962/hotpick_1_m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730972842104/flashsale_2_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730972846162/flashsale_2_m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730972870597/flashsale_3_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730972874201/flashsale_3_m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730972900040/flashsale_4_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730972903054/flashsale_4_m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730972906310/flashsale_5_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730972909262/flashsale_5_m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730972951225/flashsale_6_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730972954919/flashsale_6_m.jpg',
        },
    ],
    es: euList,
    it: euList,
    de: euList,
    fr: euList,
};

const activityTime = {
    start: new Date('2024/11/21 16:00:00 GMT+8').getTime(),
    end: new Date('2024/11/25 16:00:00 GMT+8').getTime(),
};

const EUProduct2: FC<IProps> = ({ title, desc, id, module }) => {
    const { locale } = getLocal();
    const { pageStatus } = useMonthlyStore();
    const { productList } = useProductList(module, locale);
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const { t } = useLang('appreciationday');

    const isLimited = systemTime >= activityTime.start && systemTime <= activityTime.end;

    const picList = imgList[locale];

    if (!productList || productList.length === 0 || (pageStatus !== IPageStatus.ACTIVITY && !isLimited)) return <></>;

    return (
        <div className={`${styled.products_eu}`} id={id}>
            <Header title={title} desc={desc} />
            <div className="products_eu_container">
                {productList.map((item, i) => (
                    <div className="item_card" key={item.productId}>
                        <div className="card_img">
                            <EditorImg className="img" pc={picList[i]?.pc || item.imageUrl} h5={picList[i]?.h5 || item.imageUrl} />
                        </div>
                        <div className="card_text">
                            <div className="card_text_wrapper">
                                <div className="title">{item.title}</div>
                                {item.subtitle1 && <div className="subtitle1">{item.subtitle1}</div>}
                                {item.subtitle2 && <div className="subtitle1">{item.subtitle2}</div>}
                            </div>
                            <div className="context_price">
                                <div className="price_1">{item.memberPrice2}</div>
                                {item.compareAtPrice2 !== item.memberPrice2 && <div className="price_2">{item.compareAtPrice2}</div>}
                            </div>
                            <div className="button_action">
                                <EditorLink href={item.productUrl} target="_blank">
                                    <button className="button_learn_more">{t('learn_more')}</button>
                                </EditorLink>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EUProduct2;
